import React from "react";
import SiteConfigContainer from "../../../containers/Settings/SiteConfig";

const SiteConfigScreen = () => {
  return <SiteConfigContainer />;
};
export default SiteConfigScreen;
